import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import React from 'react'

import Layouts from '@/layouts/Layouts'
import { getGalleryDetail } from '@/services/gallery'
import { formatEpoch, htmlToText, limitText } from '@/utils/formatter'
import { useAppSelector } from '@/utils/hooks'

import AlbumCard from '../components/AlbumCard'
import AlbumCarousel from '../components/AlbumCarousel'

const AlbumSlug = () => {
  const router = useRouter()
  const { t } = useTranslation()

  const paramsDetail = {
    params: { slug: String(router.query?.slug) },
    headers: { 'Accept-Language': String(router.locale) },
  }

  const { data: detailGallery } = useAppSelector(getGalleryDetail.select(paramsDetail))

  return (
    <Layouts
      title={t('album:title')}
      description={htmlToText(limitText(String(detailGallery?.data.description)))}
    >
      detailGallery?.data.description
      <main className='min-h-screen w-full bg-white pt-14 lg:pt-18'>
        <section className='container flex flex-col gap-6 py-12.5 pt-6 lg:gap-12.5 lg:pb-25'>
          <div className='flex flex-col gap-6'>
            <header>
              <h3 className='mb-2 text-lg font-bold text-dark lg:text-2xl'>{detailGallery?.data.title}</h3>

              <p className='text-sm text-gray-2 lg:text-base lg:tracking-[-0.176px]'>
                {formatEpoch(detailGallery?.data.createdAt ?? 0, 'EEEE, dd LLLL yyyy | T', router.locale)}
              </p>
            </header>

            {detailGallery && detailGallery.data && (
              <>
                <AlbumCarousel data={detailGallery.data.galleryMedias} />
              </>
            )}
          </div>

          <div className='flex flex-col gap-4'>
            <h3 className='text-2xl font-bold text-dark'>{t('album:detail.description')}</h3>

            <div
              className='description break-words text-sm text-dark lg:text-base '
              dangerouslySetInnerHTML={{ __html: detailGallery?.data.description as string }}
            />
          </div>

          {detailGallery && detailGallery.data.otherGalleryAlbum.length > 0 && (
            <div className='flex flex-col gap-6'>
              <h3 className='text-2xl font-bold text-dark'>{t('album:detail.others')}</h3>

              <div className='grid grid-cols-1 gap-y-6 lg:grid-cols-3 lg:gap-x-[31.5px] lg:gap-y-8'>
                {detailGallery.data.otherGalleryAlbum.map((card) => (
                  <AlbumCard
                    locale={router.locale}
                    data={card}
                    href='/media/album'
                    key={card.xid}
                  />
                ))}
              </div>
            </div>
          )}
        </section>
      </main>
    </Layouts>
  )
}

export default AlbumSlug
